query ParentCandidates(
  $cloudId: ID!
  $projectId: ID!
  $issueTypeId: ID!
  $searchTerm: String
) {
  jira {
    parentCandidatesWithInfoForNewIssue(
      cloudId: $cloudId
      projectId: $projectId
      issueTypeId: $issueTypeId
      searchTerm: $searchTerm
    ) {
      parentCandidates {
        edges {
          node {
            key
            id
            fieldsById(ids: ["issuetype", "summary"]) {
              edges {
                node {
                  fieldId
                  # Issue Type field of Parent Issue
                  # We need this to get the avatar
                  ... on JiraIssueTypeField {
                    issueType {
                      name
                      avatar {
                        large
                      }
                    }
                  }
                  # Summary field of Parent Issue
                  # We need this to display the name of the parent issue
                  ... on JiraSingleLineTextField {
                    text
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
